import { render } from "./SettingsPanelBulk.vue?vue&type=template&id=327c1d51"
import script from "./SettingsPanelBulk.vue?vue&type=script&lang=ts"
export * from "./SettingsPanelBulk.vue?vue&type=script&lang=ts"
script.render = render

export default script